import React, {Fragment, useState} from "react";
import BulkLocationEditorSpecialHours from "../hours/BulkLocationEditorSpecialHours";


function BulkLocationEditorKeywords({overwriteInLocationPatch, locationPatchKeywords}) {
    /* Keywords looks like, keyword:"",localArea:"", normalizedLocalArea:"", normalizedKeyword:""
     where normalized fields are just lowercase versions.
     */
    const _state = locationPatchKeywords.map(obj => obj) //make  a copy
    const [keywordModel, setKeywordModel] = useState(_state);

    const setKeyword = (keywordIndex) => (event) => {
        let updatedKeywordModel = [...keywordModel]
        updatedKeywordModel[keywordIndex].keyword = event.target.value
        setKeywordModel(updatedKeywordModel)
        overwriteInLocationPatch({
            "additionalCategories": updatedKeywordModel
            }
        )
    }

    const removeKeywordBlock = (keywordIndex) => () => {
        const updatedKeywordModel = keywordModel.filter((item, index) => keywordIndex !== index);
        setKeywordModel(updatedKeywordModel)
        overwriteInLocationPatch({
                "additionalCategories": updatedKeywordModel
            }
        )
    }

    const setLocalArea = (keywordIndex) => (event) => {
        let updatedKeywordModel = [...keywordModel]
        updatedKeywordModel[keywordIndex].localArea = event.target.value
        setKeywordModel(updatedKeywordModel)
        overwriteInLocationPatch({
                "additionalCategories": updatedKeywordModel
            }
        )
    }

    const addKeywordBlock = () => {
        const blank = {keyword: "", localArea: "", normalizedKeyword: "", normalizedLocalArea: ""}
        const updatedKeywordModel = keywordModel.concat([blank])
        setKeywordModel(updatedKeywordModel)
    }

    return <div className="card-spacer-top card-spacer-bottom">
        <h5>Additional Keyword Tracking</h5>
        <div className="card-spacer-bottom">Your location's rankings will be monitored when people search for these
            terms.
        </div>
        <form className="form-inline card-spacer-top">
            <table className="bulkLocationEditorSpecialHours">
                <tbody>
                {keywordModel.length>0 && <tr><th></th><th>Keyword</th><th>Location</th></tr>}
                {keywordModel.map((keywordBlock, keywordIndex) => {
                    return <Fragment key={keywordIndex}>
                        <tr className="card-spacer-top">
                            <td>
                                <label>
                                    <button type="button" className="btn btn-secondary"
                                            onClick={removeKeywordBlock(keywordIndex)}>
                                        <i className="fas fa-trash-alt"/>
                                    </button>
                                </label>
                            </td>
                            <td>
                                <div>
                                    <input className="form-control" type="text" value={keywordBlock.keyword}
                                           onChange={setKeyword(keywordIndex)}/>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <input className="form-control" type="text" value={keywordBlock.localArea}
                                           onChange={setLocalArea(keywordIndex)}/>
                                </div>
                            </td>
                        </tr>
                    </Fragment>
                })}

                </tbody>
            </table>
        </form>

        {keywordModel.length < 15 &&  <button type="button" className="btn btn-secondary" onClick={addKeywordBlock}>
            <i className="far fa-plus"/>
        </button>}
    </div>

}

export default BulkLocationEditorKeywords